document.addEventListener("DOMContentLoaded", function () {
  function stickyAddToCart(event, isFocusWithin = false) {
    const section = document.querySelector(".custom_main_product")
    const quantityAddCartWrapper = document.querySelector(".sticky_add_to_cart")

    if (!section || !quantityAddCartWrapper) {
      console.error("Section or Add to Cart element not found!")
      return
    }

    const sectionHeight = section.offsetHeight

    if (window.scrollY > sectionHeight || isFocusWithin) {
      quantityAddCartWrapper.classList.add("active_sticky")
    } else {
      quantityAddCartWrapper.classList.remove("active_sticky")
    }
  }

  window.addEventListener("scroll", stickyAddToCart)
  document
    .querySelector(".sticky_add_to_cart")
    .addEventListener("focusin", function (event) {
      stickyAddToCart(event, true)
    })
  document
    .querySelector(".sticky_add_to_cart")
    .addEventListener("focusout", stickyAddToCart)
  stickyAddToCart() // Initial check on page load
})
